export const navLinks = [
  { label: 'Work', href: '#work' },
  { label: 'Services', href: '#services' },
  { label: 'Ventures', href: '#engagements' },
  { label: 'Recognition', href: '#awards' },
  { label: 'Journal', href: '#journal' },
]

// The three arms of LAEBEL, shown in the site menu
export const laebelArms = [
  { name: 'Studios', line: 'The factory: terminals, film, campaigns', href: '#work' },
  { name: 'Ventures', line: 'Media power and AI infrastructure for equity', href: '#engagements' },
  { name: 'Labs', line: 'The in-house AI-OS behind everything', href: '#services' },
]

// Placeholder logo source (credit: "Letter L" by Nakulah.design)
export const brandLogoSrc =
  'https://cdn.magicpatterns.com/uploads/nebSLsNyWhokRmfw8zkTUD/image.png'

// Placeholder background showreel (third-party reel — replace with your own before publishing)
export const heroVideo = 'https://noth-in.b-cdn.net/showreel-nothin_DEF.mp4'

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/fba5dce3-67c8-4c8a-97a8-5ad93fdbbf2e.jpg'

export const heroIntro =
  'The AI-native brand venture studio of the KAYS & KAYS ecosystem — building and operating brands, terminals and media assets on a private equity foundation.'

export const reelPoster =
  'https://cdn.magicpatterns.com/patterns/generated-images/1e46666c-df4e-4d0d-900a-6170ca3fd729.jpg'

export const introStatement = [
  { text: 'We do not design brands. We build and operate ', strong: false },
  { text: 'the environments', strong: true },
  { text: ' they belong to.', strong: false },
]

// The KAYS & KAYS ecosystem LAEBEL builds for
export const logoWall = [
  { name: 'KAYS & KAYS', mark: 'dot', style: 'font-semibold tracking-[-0.03em]' },
  { name: 'superluxury', mark: 'aperture', style: 'font-medium lowercase tracking-[-0.02em]' },
  { name: 'REALTI', mark: 'none', style: 'font-bold italic tracking-[0.02em]' },
  { name: 'Ineq', mark: 'waves', style: 'font-normal tracking-[-0.02em]' },
  { name: 'erfolgsmensch', mark: 'asterisk', style: 'font-light tracking-[-0.01em]' },
  { name: 'TVC', mark: 'none', style: 'font-bold tracking-[-0.04em]' },
]

export const aboutStatement = [
  { text: 'One source for spaces, brand IDs, terminals and media — built in ', strong: false },
  { text: 'days', strong: true },
  { text: ' where others need months.', strong: false },
]

export const workStatement = [
  { text: 'Founders and investors on building with us, in their ', strong: false },
  { text: 'own words', strong: true },
  { text: '.', strong: false },
]

export const selectedWork = [
  {
    title: 'Maison Obsidian',
    category: 'Haute Parfumerie, Film',
    description: 'Identity, cinematic film and a private terminal for a haute parfumerie house’s first collection.',
    year: '2026',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6ac78abf-10ff-44bd-8bb9-54bee094f143.jpg',
  },
  {
    title: 'Halcyon Bio',
    category: 'Visual Intelligence, Identity',
    description: 'Identity and a visual intelligence system for a neuro-performance and longevity biotech.',
    year: '2025',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4808daf7-468f-408d-a9fc-49bcf9fc68cf.jpg',
  },
  {
    title: 'Sable Estates',
    category: 'Terminal, Data Room',
    description: 'A private data room and investor terminal for off-market villas in Mallorca and Dubai.',
    year: '2025',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c752d0f-dfe5-46a6-902b-426d0ebb1c44.jpg',
  },
]

// Single-word disciplines shown as the small third line under each project
export const projectTags: Record<string, string[]> = {
  'Maison Obsidian': ['Identity', 'Film', 'Terminal'],
  'Halcyon Bio': ['Identity', 'Visuals', 'Longevity'],
  'Sable Estates': ['Terminal', 'Data', 'Real Estate'],
  'Meridian Office': ['AI-OS', 'Agents', 'Equity'],
  'Aurel Eyewear': ['Identity', 'Film', 'Campaign'],
  'Orbit Aero': ['Identity', 'Film', 'Equity'],
  Solace: ['Spaces', 'Identity', 'Longevity'],
  'Maison Dune': ['Spaces', 'Terminal', 'Equity'],
  'Atelier Vauclair': ['Identity', 'Film', 'Campaign'],
  'Nowa Residences': ['Terminal', 'Visuals', 'Real Estate'],
  'Port Hercule': ['Film', 'Distribution', 'SuperLuxury'],
  'Lindt & Aare': ['Identity', 'Terminal', 'AI-OS'],
}

export const projects = [
  {
    title: 'Meridian Office',
    summary: 'A private AI-OS with proprietary agents and RAG memory for a single family office',
    tag: 'AI-OS',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/aca46c21-3108-46c4-bc34-caf4d61162c6.jpg',
  },
  {
    title: 'Aurel Eyewear',
    summary: 'Identity, campaign film and launch for an independent luxury eyewear house',
    tag: 'Eyewear',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/53c59d5a-3ea3-43c2-b2da-4a0206f815a2.jpg',
  },
  {
    title: 'Maison Obsidian',
    summary: 'A haute parfumerie house, built as a system and an investment',
    tag: 'Luxury',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6ac78abf-10ff-44bd-8bb9-54bee094f143.jpg',
  },
  {
    title: 'Sable Estates',
    summary: 'A private data room for off-market villas in Mallorca and Dubai',
    tag: 'Real Estate',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c752d0f-dfe5-46a6-902b-426d0ebb1c44.jpg',
  },
  {
    title: 'Orbit Aero',
    summary: 'Private aviation for the Gulf–Europe corridor',
    tag: 'Aviation',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a1d16a37-34ff-46a9-b297-de24599542e8.jpg',
  },
  {
    title: 'Solace',
    summary: 'Longevity and neuro-performance residences, Mallorca',
    tag: 'Longevity',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/67f61863-0db8-4917-b845-9813cd8f92ba.jpg',
  },
  {
    title: 'Maison Dune',
    summary: 'A desert hospitality asset, held through LAEBEL Ventures',
    tag: 'Hospitality',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/44d533e2-46c0-4935-acba-ef4d0fe5f211.jpg',
  },
  {
    title: 'Atelier Vauclair',
    summary: 'Identity and cinematic film for an independent watch manufacture',
    tag: 'Watches',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4b702e2e-1739-47eb-b4b4-f9ed828e3394.jpg',
  },
  {
    title: 'Nowa Residences',
    summary: 'A sales terminal and build-phase tracking for a Warsaw development',
    tag: 'Real Estate',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/63c8f866-594a-4723-978c-fa81d690f35c.jpg',
  },
  {
    title: 'Port Hercule',
    summary: 'Cinematic yacht series, distributed through SuperLuxury in Monaco',
    tag: 'SuperLuxury',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/abede1a4-7562-4b8a-971b-c9cf6a367c56.jpg',
  },
  {
    title: 'Lindt & Aare',
    summary: 'A discreet client terminal and AI-OS for a Zurich private bank',
    tag: 'FinTech',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ef3c189b-1577-4789-92f3-8eb2facfda01.jpg',
  },
]

export const services = [
  {
    name: 'LAEBEL Ventures',
    detail: 'The owner. Brand building and AI infrastructure exchanged for equity.',
  },
  {
    name: 'LAEBEL Studios',
    detail: 'The factory. Terminals, cinematic film and campaigns for luxury brands.',
  },
  {
    name: 'LAEBEL Labs',
    detail: 'The brain. Proprietary agents, RAG memory and automated workflows.',
  },
  {
    name: 'Visual Intelligence',
    detail: 'Editorial design and quiet, C-level visuals across every touchpoint.',
  },
]

export const reviews = [
  {
    name: 'Jonas Ekberg',
    company: 'Northwind',
    mark: 'dot',
    markStyle: 'font-semibold tracking-[-0.03em]',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/2f823c1e-3767-4512-8b00-2e06e519bd8e.jpg',
    quote:
      'LAEBEL did not pitch us a campaign. They built the terminal, the visuals and the data room our investors now see first — in weeks, not quarters. It finally looks like the company we are becoming.',
  },
  {
    name: 'Daniel Cho',
    company: 'Aperture',
    mark: 'aperture',
    markStyle: 'font-medium lowercase tracking-[-0.02em]',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/aabb04b4-5366-48d3-99d6-351ad4ecb6ad.jpg',
    quote:
      'Speed without compromise. Three launches with LAEBEL now, and not once did the pace cost us a single detail of the craft.',
  },
  {
    name: 'Clara Weiss',
    company: 'Halcyon',
    mark: 'waves',
    markStyle: 'font-normal tracking-[-0.02em]',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/c295e4f0-3785-43e6-bf09-3feef8c8ce03.jpg',
    quote:
      'They took equity instead of an invoice, and it shows. LAEBEL operates like an owner — quiet, precise and invested in every decision since day one.',
  },
  {
    name: 'Marcus Hale',
    company: 'Meridian',
    mark: 'asterisk',
    markStyle: 'font-light tracking-[-0.01em]',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0ea83af5-a4a4-4fe9-a658-aa8e42f94405.jpg',
    quote:
      'Our off-market assets in Dubai and Warsaw finally have a presence that matches their value. Visual intelligence, not advertising — exactly what our buyers expect.',
  },
  {
    name: 'Amara Okafor',
    company: 'Parallax',
    mark: 'none',
    markStyle: 'font-bold tracking-[-0.04em]',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/15734642-33e7-4136-bd69-e95a0c2d4473.jpg',
    quote:
      'No hourly rates, no noise, no excuses. Just a single source that builds what others need months for, and makes it look effortless.',
  },
]

export const engagementsStatement = [
  { text: 'Six ways into the ecosystem, all from a single ', strong: false },
  { text: 'source', strong: true },
  { text: '.', strong: false },
]

export const engagements = [
  {
    title: 'Terminal Sprint',
    duration: '2 weeks',
    bestFor: 'Founders & family offices',
    glyph: 'rise' as const,
    description:
      'A Webflow or Vercel terminal, designed and live in days — editorial, precise and running on our in-house AI-OS.',
  },
  {
    title: 'Cinematic Assets',
    duration: '3–4 weeks',
    bestFor: 'Luxury hotels & manufactures',
    glyph: 'layers' as const,
    description:
      'Cinematic film and campaign visuals, distributed through SuperLuxury and its audience of more than 1.2 million.',
  },
  {
    title: 'Brand ID System',
    duration: '6–8 weeks',
    bestFor: 'Parfumeries & watchmakers',
    glyph: 'mark' as const,
    description:
      'Positioning, identity and a complete visual system — crafted by hand, accelerated by algorithmic precision.',
  },
  {
    title: 'Visual Intelligence',
    duration: 'Per phase',
    bestFor: 'Developers & real estate',
    glyph: 'window' as const,
    description:
      'Construction-phase tracking and off-market asset visuals for Dubai, Mallorca and Warsaw, from first sketch to handover.',
  },
  {
    title: 'AI-OS Integration',
    duration: '4–8 weeks',
    bestFor: 'Operating companies',
    glyph: 'link' as const,
    description:
      'Proprietary agents, RAG memory and automated workflows that cut production costs by up to 90% at ten times the speed.',
  },
  {
    title: 'Equity Partnership',
    duration: 'Long-term',
    bestFor: 'Personal brands & founders',
    glyph: 'ripple' as const,
    description:
      'Media power, AI infrastructure and brand building, exchanged for real equity through LAEBEL Ventures — never hourly rates.',
  },
]

export const faqs = [
  {
    question: 'Is LAEBEL an agency?',
    answer:
      'No. LAEBEL is an AI-native brand venture studio built on private equity. We take on client work to fund the factory, but what we primarily build are lasting assets.',
  },
  {
    question: 'Do you bill by the hour?',
    answer:
      'Never. Studio work is scoped at a fixed price. For founders and personal brands, we often exchange brand building and infrastructure for equity instead.',
  },
  {
    question: 'How fast can you deliver?',
    answer:
      'Our in-house AI-OS lets us work at around ten times the usual speed. A terminal can be live in days; a full brand ID system in weeks.',
  },
  {
    question: 'Is your work AI-generated?',
    answer:
      'No cheap AI content, ever. AI is our operating backbone — agents, memory and workflows. Everything you see is crafted by hand, with algorithmic precision.',
  },
  {
    question: 'How does an equity partnership work?',
    answer:
      'Through LAEBEL Ventures we contribute media power, AI infrastructure and brand building in exchange for real shares in your company or asset.',
  },
  {
    question: 'Who do you work with?',
    answer:
      'One archetype: ultra-high-net-worth individuals, investors, founders and family offices — alongside top athletes and creators building lasting brands.',
  },
  {
    question: 'Where are you based?',
    answer:
      'Headquartered as a Dubai FZCO, with focus markets in Warsaw, Mallorca and Monaco, Zurich and Hamburg. We operate globally from a single source.',
  },
  {
    question: 'How does LAEBEL relate to KAYS & KAYS?',
    answer:
      'LAEBEL is the factory of the KAYS & KAYS ecosystem. The path runs from LAEBEL Studios to LAEBEL Ventures, and on to the KAYS & KAYS holding.',
  },
]

export const footerInfo = {
  country: 'DXB',
  timeZone: 'Asia/Dubai',
  email: 'hey@laebel.co',
  website: 'laebel.co',
  tagline: 'Single source of origin. Built in Dubai, operating globally.',
  marquee: 'SINGLE SOURCE OF ORIGIN®',
  socials: [
    { label: 'LinkedIn', href: '#contact' },
    { label: 'Instagram', href: '#contact' },
  ],
  legal: [
    { label: 'Imprint', href: '/legal/imprint' },
    { label: 'Privacy Policy', href: '/legal/privacy' },
    { label: 'Terms', href: '/legal/terms' },
    { label: 'Cookies', href: '/legal/cookies' },
  ],
}

export const studios = [
  {
    city: 'Dubai',
    lines: ['Dubai Silicon Oasis, DDP, Building A1', 'Dubai, United Arab Emirates'],
    phone: '+971 50 525 4282',
  },
]

export const awardsSince = '2018'

const awardImages = {
  hexa: 'https://cdn.magicpatterns.com/patterns/generated-images/aca46c21-3108-46c4-bc34-caf4d61162c6.jpg',
  torque: 'https://cdn.magicpatterns.com/patterns/generated-images/53c59d5a-3ea3-43c2-b2da-4a0206f815a2.jpg',
  obsidian: 'https://cdn.magicpatterns.com/patterns/generated-images/6ac78abf-10ff-44bd-8bb9-54bee094f143.jpg',
  vela: 'https://cdn.magicpatterns.com/patterns/generated-images/6c752d0f-dfe5-46a6-902b-426d0ebb1c44.jpg',
  refract: 'https://cdn.magicpatterns.com/patterns/generated-images/4808daf7-468f-408d-a9fc-49bcf9fc68cf.jpg',
}

export const awards = [
  { year: '2026', award: 'Site of the Day', from: 'Awwwards', project: 'Meridian Office', image: awardImages.hexa },
  { year: '2026', award: 'Best Brand Identity', from: 'Brand New', project: 'Aurel Eyewear', image: awardImages.torque },
  { year: '2025', award: 'Website of the Day', from: 'CSS Design Awards', project: 'Sable Estates', image: awardImages.vela },
  { year: '2025', award: 'Best Visual System', from: 'Behance', project: 'Halcyon Bio', image: awardImages.refract },
  { year: '2025', award: 'Packaging Gold', from: 'Pentawards', project: 'Maison Obsidian', image: awardImages.obsidian },
  { year: '2024', award: 'Developer Award', from: 'Awwwards', project: 'Meridian Office', image: awardImages.hexa },
  { year: '2024', award: 'Honourable Mention', from: 'Awwwards', project: 'Halcyon Bio', image: awardImages.refract },
  { year: '2024', award: 'Best Product Launch', from: 'Webby Awards', project: 'Sable Estates', image: awardImages.vela },
  { year: '2023', award: 'Best Motion Identity', from: 'Behance', project: 'Aurel Eyewear', image: awardImages.torque },
  { year: '2022', award: 'Site of the Month', from: 'CSS Design Awards', project: 'Maison Obsidian', image: awardImages.obsidian },
  { year: '2020', award: 'Rising Studio', from: 'Design Week', project: 'Halcyon Bio', image: awardImages.refract },
  { year: '2018', award: 'Honourable Mention', from: 'Awwwards', project: 'Meridian Office', image: awardImages.hexa },
]

export const clients = ['KAYS & KAYS', 'SuperLuxury', 'REALTI', 'INEQ', 'Erfolgsmensch', 'TVC']